import React, { Component } from 'react';
import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { auth } from '../../firebase';
import * as routes from '../../routes/routes';
import { withRouter, Link } from 'react-router-dom';

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    password: '',
    repeatPassword: '',
    error: null,
    success: false,
    validCode: null,
    verifiedCode: false,
};

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {
        auth
            .verifyPasswordResetCode(this.props.actionCode)
            .then(() => {
                this.setState({ validCode: true, verifiedCode: true });
            }, error => {
                this.setState({ error: error.message, validCode: false, verifiedCode: true });
            });
    }

    onSubmit = (event) => {
        const { password } = this.state;
        const { actionCode } = this.props;
        auth
            .confirmPasswordReset(actionCode, password)
            .then(() => {
                this.setState({ success: true });
            })
            .catch(error => {
                this.setState(updateByPropertyName('error', error));
            });
        event.preventDefault();
    }

    render() {
        const {
            password,
            repeatPassword,
            error,
            success,
            validCode,
            verifiedCode,
        } = this.state;

        const isInvalid =
            password !== repeatPassword ||
            password === '';

        let content;
        if (success) {
            content = <div>
                <Typography variant="h1">Password changed</Typography>
                <Typography>You can now sign in with your new password</Typography>
                <div style={{ flexDirection: 'row', flex: 1 }}>
                    <Link style={{ marginRight: '50px' }} to={routes.LOGIN}>Sign in</Link>
                    <Link style={{ marginLeft: '50px' }} to={routes.REGISTER}>Sign Up</Link>
                </div>
            </div>
        } else if (verifiedCode && validCode) {
            content =
                <Paper className="papper-middle-smaller">
                    <TextField
                        value={password}
                        onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
                        type="password"
                        label="New Password"
                    />
                    <TextField
                        value={repeatPassword}
                        onChange={event => this.setState(updateByPropertyName('repeatPassword', event.target.value))}
                        type="password"
                        label="Confirm New Password"
                    />
                    <Button
                        disabled={isInvalid}
                        className="formButton"
                        onClick={this.onSubmit}
                    >
                        {'Send'}
                    </Button>

                </Paper>
        } else if (verifiedCode && !validCode) {
            content = <Typography className="message-error">{error.message}</Typography>
        }

        return (
            <div className="padding-middle">
                <div style={{
                    textAlign: 'center',
                }}>
                    {content}
                </div>
            </div>
        );
    }
}

export default withRouter(UpdatePassword);


// WEBPACK FOOTER //
// ./src/components/UpdatePassword/index.js